import type { Badge } from '@/components';
import { URL_PATH } from '@/utils/route-path';
import type { ComponentProps, ReactNode } from 'react';
import { z } from 'zod';

export const sideMenuKeyEnum = z.enum([
  'analysis',
  'project',
  'comment',
  'workflow',
  'batch',
  'globalTag',
  'localTag',
  'masterTable',
  'tenantManager',
]);

export type TopMenuItem = {
  key: z.infer<typeof sideMenuKeyEnum>;
  path: `/${string}`;
  icon: ReactNode;
  label: string;
  isShowNotificationBadge?: boolean;
  notificationBadgeCount?: number;
  isShowNotificationBadgeBottom?: boolean;
  notificationBadgeCountBottom?: number;
  notificationBadgeColor?: ComponentProps<typeof Badge>['color'];
};

export const getSelectedMenuKeyByPathname = ({
  pathname,
}: {
  pathname: string;
}) => {
  if (!pathname) {
    return '';
  }
  if (pathname.includes('rs/project')) {
    return sideMenuKeyEnum.Enum.project;
  }
  if (pathname.includes('tag/global')) {
    return sideMenuKeyEnum.Enum.globalTag;
  }
  if (pathname.includes('tag/local')) {
    return sideMenuKeyEnum.Enum.localTag;
  }
  if (pathname.includes(URL_PATH.comment)) {
    return sideMenuKeyEnum.Enum.comment;
  }
  if (pathname.includes(URL_PATH.workflow)) {
    return sideMenuKeyEnum.Enum.workflow;
  }
  if (pathname.includes(URL_PATH.master)) {
    return sideMenuKeyEnum.Enum.masterTable;
  }
  if (pathname.includes(URL_PATH.tenantManager)) {
    return sideMenuKeyEnum.Enum.tenantManager;
  }
  return location.pathname.split('/')[1];
};
